import {
  TRANSFERHISTORY_LOADING,
  GET_TRANSFERHISTORY,
  GET_TRANSFERHISTORY_SUCCESS,
  GET_TRANSFERHISTORY_FAIL,
  ADD_TRANSFERHISTORY_SUCCESS,
  ADD_TRANSFERHISTORY_FAIL,
  DELETE_TRANSFERHISTORY_SUCCESS,
  DELETE_TRANSFERHISTORY_FAIL,
  UPDATE_TRANSFERHISTORY_SUCCESS,
  UPDATE_TRANSFERHISTORY_FAIL,
  TRANSFERHISTORY_RESET
} from "./actionType";

const INIT_STATE = {
  transferHistories: [],
  error: {},
};

const TransferHistory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TRANSFERHISTORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TRANSFERHISTORY:
          return {
            ...state,
            transferHistories: action.payload.data,
            isTransferHistoryCreated: false,
            isTransferHistorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TRANSFERHISTORY_FAIL:
      switch (action.payload.actionType) {
        case GET_TRANSFERHISTORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTransferHistoryCreated: false,
            isTransferHistorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TRANSFERHISTORY: {
      return {
        ...state,
        isTransferHistoryCreated: false,
        loading: true,
      };
    }

    case TRANSFERHISTORY_LOADING: {
      return {
        ...state,
        isTransferHistoryCreated: false,
        loading: true,
      };
    }

    case ADD_TRANSFERHISTORY_SUCCESS:
      return {
        ...state,
        isTransferHistoryCreated: true,
        loading: false,
        transferHistories: [action.payload.data, ...state.transferHistories],
      };

    case ADD_TRANSFERHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TRANSFERHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isTransferHistoryCreated: true,
        transferHistories: state.transferHistories.filter(
          transferHistory => transferHistory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TRANSFERHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TRANSFERHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isTransferHistoryCreated: true,
        transferHistories: state.transferHistories.map(transferHistory =>
          transferHistory.id.toString() === action.payload.data.id.toString() ? { ...transferHistory, ...action.payload.data } : transferHistory
        ),
      };

    case UPDATE_TRANSFERHISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TRANSFERHISTORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default TransferHistory;